export function clearNavigationStack() {
  const currentLength = window.history.length;
  const startLength = window.history.state?.startLength;

  if (!startLength || typeof startLength !== 'number') {
    console.warn('[clearNavigationStack] No startLength in history.state, cannot clear safely');
    return;
  }

  const stepsToGo = startLength - currentLength;

  if (stepsToGo === 0) {
    return;
  }

  if (stepsToGo > 0) {
    console.warn('[clearNavigationStack] startLength > currentLength, possible external link');
    return;
  }

  window.history.go(stepsToGo);
}
